export default __webpack_public_path__ + "src/images/packages/saseka-tented-camp/d9bbeec5b79a439445bb9d80366f27e1-5.jpg";